<template>
    <div>
        <b-row>
            <b-col cols="12" class="mb-4">
                <b-button variant="outline-primary" class="float-right" @click="toggleAddModal">+ New Sale Team</b-button>
            </b-col>

            
            <b-col md="6" xl="4" cols="12" class="mb-4" v-for="(card, index) in cards" :key="index">
                <b-card no-body class="h-100">
                    <b-card-header>Sale Team - {{ card.team_leader.name }}</b-card-header>
                    <div class="p-3 h-100">
                        <ol>
                            <li v-for="(member, index) in card.team_members" :key="index" class="my-3">
                                <div class="d-flex justify-content-between align-items-center">
                                    <span>{{ member.name }}<b class="text-red">{{ member.suspend_status ? ' - Suspended' : '' }}</b></span>
                                    <div>
                                        <b-button variant="success" class="px-2 py-1" @click="underDevelopment">Tree</b-button>
                                        <b-button variant="primary" class="px-2 py-1" @click="downlineBtn(card.team_members[index])">Upline</b-button>
                                    </div>
                                </div>
                            </li>
                        </ol>
                    </div>
                    <b-card-footer class="px-2">
                        <b-button variant="danger" class="float-right" @click="onDeleteTeam(card)">Delete</b-button>
                        <b-button type="button" variant="primary" class="float-right mx-2" @click="editCard(card.hub_team_id, index)">Edit</b-button>
                    </b-card-footer>
                </b-card>
            </b-col>
        </b-row>

        <!-- Modal Add New Sale Team -->
        <modal :show.sync="modals.sale_team_form">
            <h6 slot="header" class="modal-title">Add New Sale Team</h6>
            <b-row>
                <b-col cols="12">
                    <b-form-group label="Team Leader:" label-cols="5" label-cols-md="4">
                        <el-select v-model="form.team_leader" filterable placeholder="Select Team Leader">
                            <el-option v-for="option in selectTeamLeaderOptions"
                                    :key="option.id"
                                    :label="option.name"
                                    :value="option.id">
                            </el-option>                        
                        </el-select>
                    </b-form-group>
                </b-col>
                <b-col cols="12">
                    <b-form-group label="Team Member:" label-cols="5" label-cols-md="4">
                        <el-select v-model="form.team_member" filterable multiple placeholder="Select Team Member">
                            <el-option v-for="option in selectTeamMemberOptions"
                                :key="option.id"
                                :label="option.name"
                                :value="option.id">
                            </el-option>
                        </el-select>
                    </b-form-group>
                </b-col>
            </b-row>
            <div slot="footer">
                <b-button type="submit" variant="primary" class="float-right mx-2" @click="createData">Save</b-button>
                <b-button type="button" class="float-right mx-2" @click="toggleAddModal">Back/Close</b-button>
            </div>
        </modal>

        <!-- Modal Edit Sale Team -->
        <modal :show.sync="modals.sale_team_edit_form">
            <h6 slot="header" class="modal-title">Edit Sale Sale Team</h6>
            <b-row>
                <b-col cols="12">
                    <b-form-group label="Team Leader:" label-cols="5" label-cols-md="4">
                        <el-select v-if="form" v-model="form.team_leader" filterable placeholder="Select Team Leader">
                            <el-option v-for="option in selectedTeamLeaderOptions"
                                    :key="option.id"
                                    :label="option.name"
                                    :value="option.id">
                            </el-option>
                        </el-select>
                    </b-form-group>
                </b-col>
                <b-col cols="12">
                    <b-form-group label="Team Member:" label-cols="5" label-cols-md="4">
                        <el-select @change="selectTeamMember" v-model="form.team_member" filterable multiple placeholder="Select Team Member">
                            <el-option v-for="option in selectedTeamMemberOptions"
                                :key="option.id"
                                :label="option.name"
                                :value="option.id">
                            </el-option>
                        </el-select>
                    </b-form-group>
                </b-col>
                <b-col cols="12" v-if="editingCard" class="border rounded">
                    <ul>
                        <li v-for="(member, index) in editingCard.team_members" :key="index" class="my-3">
                            <div class="d-flex justify-content-between align-items-center">
                                <span>{{ member.name }}<b class="text-red">{{ member.suspend_status ? ' - Suspended' : '' }}</b></span>
                                <div>
                                    <!-- <b-button variant="warning" size="sm" @click="underDevelopment">Suspend</b-button> -->
                                    <b-button variant="danger" @click="deleteMemberList(member.id)">Delete</b-button>
                                </div>
                            </div>
                        </li>
                    </ul>
                </b-col>
            </b-row>
            <br>
            <template slot="footer">
                <b-button type="button" class="float-right mx-2" @click="toggleEditModal(editingCard.hub_team_id)">Back/Close</b-button>
                <b-button type="submit" variant="primary" class="float-right mx-2" @click="updateData(editingCard.hub_team_id, editingIndex)">Save</b-button>
            </template>
        </modal>

        <!-- Modal Downline -->
        <modal :show.sync="modals.downline_modal" v-click-outside="toggleEditModal">
            <h6 slot="header" class="modal-title">{{ memberSelected.name }} <span class="text-red">{{ memberSelected.suspend_status ? '- Suspended' : '' }}</span></h6>
            <!-- <b-row> -->
                <b-col cols="12">
                    <b-form-group label="Upline: " label-cols="3" label-cols-md="2" class="mt-4">
                        <el-select v-model="upline" placeholder="Select" filterable>
                            <el-option v-for="option in selectUserListOptions"
                                :key="option.id"
                                :label="option.name"
                                :value="option.id">
                            </el-option>
                        </el-select>
                    </b-form-group>
                </b-col>
            <br>
            <template slot="footer">
                <!-- <base-button v-else type="button" class="btn btn-warning float-right mx-2" @click="onActiveUser(memberSelected)">Re-Active</base-button> -->
                <b-button type="button" variant="secondary" class="float-right mx-2" @click="toggleDownlineModal">Back/Close</b-button>
                <b-button v-if="!memberSelected.suspend_status" type="button" variant="warning" class="float-right mx-2" @click="onSuspendUser(memberSelected)">Suspend</b-button>
                <b-button type="submit" variant="primary" class="float-right mx-2" @click="onUpdateTeamMemberDetail(memberSelected.hub_team_member_id)">Save</b-button>
            </template>
        </modal>
    </div>
</template>
<script>
    import { Button, Select, Option, Tag } from 'element-ui'
    import {axios, services, getHeader, swal } from '@/assets/js/httpImports.js'
    import notifyFunctionMixin from '@/assets/js/notifyFunctionMixin.js'
    
    export default {
        name: 'new-sale-team',
        mixins: [notifyFunctionMixin],
        components: {
            [Button.name]: Button,
            [Select.name]: Select,
            [Option.name]: Option,
            [Tag.name]: Tag,
        },
        data() {
            return {
                cards: [
                    {
                        team_leader: '',
                        team_members: []
                    },
                ],
                form: {
                    team_leader: '',
                    team_member: [],
                },
                selectedIds: [],
                selectTeamLeaderOptions: [],
                selectTeamMemberOptions: [],
                selectUserListOptions: [],
                selectedTeamLeaderOptions: [],
                selectedTeamMemberOptions: [],
                members: [
                    { id: 213, name: 'Mena' },
                    { id: 873, name: 'Duncan' },
                    { id: 35, name: 'Jocelyn' },
                    { id: 346, name: 'Hong Long' },
                    { id: 856, name: 'James' },
                    { id: 983, name: 'Wong Chang Hou' },
                ],
                modals: {
                    sale_team_form: false,
                    sale_team_edit_form: false,
                    downline_modal: false,
                },
                editingCard: null,
                editingIndex: '',
                memberSelected: '',
                upline: ''
            }
        },
        created() {
            this.hubTeamList();
        },
        methods: {
            toggleAddModal() {
                this.resetForm();
                this.modals.sale_team_form = !this.modals.sale_team_form;
                if(this.modals.sale_team_form)
                {
                    this.getCreateHubSaleManagerList();
                    this.getCreateHubTeamMemberList();
                }
            },
            toggleEditModal(hub_team_id) {
                this.modals.sale_team_edit_form = !this.modals.sale_team_edit_form;
                if(this.modals.sale_team_edit_form)
                {
                    this.getEditHubSaleManagerList(hub_team_id);
                    this.getEditHubTeamMemberList(hub_team_id);
                }
            },
            toggleDownlineModal() {
                this.modals.downline_modal = !this.modals.downline_modal;
            },
            resetForm() {
                this.form = {
                    team_leader: '',
                    team_member: []
                };
                this.selectedIds = [];
            },
            hubTeamList() {
                axios.get(services.hub + 'show_hub_team_by_hub_id/' + this.$route.params.id, { headers: getHeader() })
                .then(response => {
                    this.cards = response.data.data
                })
                .catch ( error => {
                    this.errorFunction(error, "Showing User Listing failed: " + error.response.data.message) 
                });
            },
            getCreateHubSaleManagerList() {
                axios.get(services.hub + 'get_create_hub_team_user_options_list/leader', { headers: getHeader() })
                .then(response => {
                    this.selectTeamLeaderOptions = response.data.data
                })
                .catch ( error => {
                    this.errorFunction(error, "Showing User Listing failed: " + error.response.data.message) 
                });
            },
            getEditHubSaleManagerList(hub_team_id) {
                axios.get(services.hub + 'get_edit_hub_team_user_options_list/leader/' + hub_team_id, { headers: getHeader() })
                .then(response => {
                    this.selectedTeamLeaderOptions = response.data.data
                })
                .catch ( error => {
                    this.errorFunction(error, "Showing User Listing failed: " + error.response.data.message) 
                });
            },
            getCreateHubTeamMemberList() {
                axios.get(services.hub + 'get_create_hub_team_user_options_list/member', { headers: getHeader() })
                .then(response => {
                    this.selectTeamMemberOptions = [...response.data.data]
                })
                .catch ( error => {
                    this.errorFunction(error, "Showing User Listing failed: " + error.response.data.message) 
                });
            },
            getEditHubTeamMemberList(hub_team_id) {
                axios.get(services.hub + 'get_edit_hub_team_user_options_list/member/' + hub_team_id, { headers: getHeader() })
                .then(response => {
                    this.selectedTeamMemberOptions = [...response.data.data]
                })
                .catch ( error => {
                    this.errorFunction(error, "Showing User Listing failed: " + error.response.data.message) 
                });
            },
            getUserList() {
                axios.get(services.access_control + 'user', { headers: getHeader() })
                .then(response => {
                    this.selectUserListOptions = response.data.data
                })
                .catch ( error => {
                    this.errorFunction(error, "Showing User Listing failed: " + error.response.data.message) 
                });
            },
            createData() {
                if(!this.form.team_leader)
                {
                    this.redErrorNotify( '<b>Invalid Input : Team Leader is Mandatory </b>')
                }
                else 
                {
                    const postData = {
                        hub_id: this.$route.params.id,
                        user_id: this.form.team_leader,
                    }
                    const str = JSON.stringify(postData);

                    axios.post(services.hub + 'hub_team', postData ,{ headers: getHeader() })
                    .then ( response => {
                        if (response.status === 200)
                        {
                            this.$notify({
                                message:
                                '<b>New Hub Sale Team </b> - Successfully Created.',
                                timeout: 10000,
                                icon: 'ni ni-bell-55',
                                type: 'default',
                            });
                            
                            this.createHubTeamMemberData(response.data.data.hub_team_id);
                        }
                    })
                    .catch ( error => {
                        this.errorFunction(error, "Create Hub Sale Team Failed")
                    })
                    .finally(() => {
                        this.reloadPage()
                        this.toggleAddModal();
                    });
                }
            },
            createHubTeamMemberData(hub_team_id) {
                const postData = {
                    hub_id: this.$route.params.id,
                    hub_team_id: hub_team_id,
                    member_id: this.form.team_member,
                }

                axios.post(services.hub + 'hub_team_member', postData, { headers: getHeader() })
                .then(() => {
                    this.$notify({
                        message:
                        '<b>Hub Sale Team Member </b> - Successfully Updated.',
                        timeout: 10000,
                        icon: 'ni ni-bell-55',
                        type: 'default',
                    });
                })
                .catch( error => {
                    this.errorFunction(error, "Insert Hub Team Member Failed")
                })
                .finally( () => {
                    this.reloadPage();
                });
                
            },
            reloadPage() {
                this.hubTeamList();
                // this.getCreateUserOptionsList();
            },
            getEditHubTeamUserOptionsList(filter_type, hub_team_id) {
                axios.get(services.hub + 'get_edit_hub_team_user_options_list/' + filter_type + '/' + hub_team_id, { headers: getHeader() })
                .then(response => {
                    if(filter_type == 'leader')
                    {
                        this.selectedTeamLeaderOptions = response.data.data
                    }
                    else if(filter_type == 'member')
                    {
                        this.selectedTeamMemberOptions = response.data.data
                    }
                })
                .catch ( error => {
                    this.errorFunction(error, "Showing User Listing failed: " + error.response.data.message) 
                });
            },
            getSelectedHubTeam(hub_team_id) {
                axios.get(services.hub + 'hub_team/' + hub_team_id, { headers: getHeader() })
                .then(response => {
                    let result = response.data.data.team_leader.id;
                    this.form.team_leader = result;
                })
                .catch ( error => {
                    this.errorFunction(error, "Get Team Leader failed: " + error.response.data.message) 
                });

                axios.get(services.hub + 'show_hub_team_member_by_hub_team_id/' + hub_team_id, { headers: getHeader() })
                .then(response => {
                    let team_members = response.data.data
                    this.form.team_member = [];

                    Object.keys(response.data.data).forEach((key) => {
                        this.form.team_member.push(team_members[key].team_member.id);
                    });
                })
                .catch ( error => {
                    this.errorFunction(error, "Showing User Listing failed: " + error.response.data.message) 
                });
            },
            editCard(hub_team_id, index) {
                this.toggleEditModal(hub_team_id);
                this.editingCard = {...this.cards[index]};
                this.selectedIds = this.cards[index].team_members.map(member => member.id);
                this.editingIndex = index;
                this.getSelectedHubTeam(hub_team_id);
            },
            selectTeamMember() {
                this.editingCard.team_members = this.selectedTeamMemberOptions.filter(member => this.form.team_member.includes(member.id));
            },
            editExistingCard(index) {
                if (this.selectedIds.length) {
                    const card = {
                        team_leader: this.editingCard.team_leader,
                        team_member: this.members.filter(member => this.selectedIds.includes(member.id)),
                    };
                    this.cards[index] = card;
                    this.resetForm();
                    this.toggleEditModal();
                }
            },
            updateData(hub_team_id, index) {
                const postData = {
                    hub_id: this.$route.params.id,
                    user_id: this.form.team_leader,
                }
                const str = JSON.stringify(postData);

                axios.put(services.hub + 'hub_team/' + hub_team_id, postData ,{ headers: getHeader() })
                .then ( response =>  {
                    if (response.status === 200)
                    {
                        this.$notify({
                            message:
                            '<b>Hub Sale Team - ' + response.data.data.team_leader.name + ' </b> - Successfully Updated.',
                            timeout: 10000,
                            icon: 'ni ni-bell-55',
                            type: 'default',
                        });
                        this.createHubTeamMemberData(response.data.data.hub_team_id);
                    }
                })
                .catch ( error => {
                    this.errorFunction(error, "Update Hub Sale Team Failed")
                })
                .finally(() => {
                    this.reloadPage()
                });
            },
            onUpdateTeamMemberDetail(hub_team_member_id) {
                const postData = {
                    parent_user_id: this.upline
                };

                axios.put(services.hub + 'hub_team_member/' + hub_team_member_id, postData ,{ headers: getHeader() })
                .then ( response => {
                    if (response.status === 200)
                    {
                        this.$notify({
                            message:
                            '<b>Hub Sale Team Member - ' + response.data.data.team_member.name + "'s Upline Data </b> - Successfully Updated.",
                            timeout: 10000,
                            icon: 'ni ni-bell-55',
                            type: 'default',
                        });
                        this.reloadPage();
                    }
                })
                .catch ( error => {
                    this.errorFunction(error, "Update Hub Sale Team Upline Data Failed")
                })
            },
            onDeleteTeam(row) {
                swal.fire({
                    title: 'Are you sure?',
                    text: 'You will delete Sale Team - ' + row.team_leader.name,
                    icon: 'warning',
                    showCancelButton: true,
                    confirmButtonText: 'Yes, delete it!',
                }).then((result) => {
                /* Read more about isConfirmed, isDenied below */
                    if (result.isConfirmed) {
                        axios.delete(services.hub + 'hub_team/' + row.hub_team_id,{ headers: getHeader() })
                        .then ( response => {
                            if (response.status === 200)
                            {
                                this.$notify({
                                    message:
                                        '<b>Hub Sale Team : ' + row.team_leader.name + '</b> - Successfully Deleted.',
                                    timeout: 10000,
                                    icon: 'ni ni-bell-55',
                                    type: 'default',
                                });
                                this.reloadPage();
                            }
                        })
                        .catch ( error => {
                            this.errorFunction(error, "Delete Hub Team")
                        });
                    } 
                })
            },
            onSuspendUser(member) {
                swal.fire({
                    title: 'Are you sure you want to suspend this user - <b>'+ member.name +'</b> ?',
                    text: "You won't be able to revert this!",
                    icon: 'warning',
                    showCancelButton: true,
                    confirmButtonText: 'Yes, suspend it!',
                }).then((result) => {
                /* Read more about isConfirmed, isDenied below */
                    if (result.isConfirmed) {
                        axios.delete(services.access_control + 'user/' + member.id,{ headers: getHeader() })
                        .then ( response => {
                            if (response.status === 200)
                            {
                                this.$notify({
                                    message:
                                        '<b>User : ' + member.name + '</b> - Successfully Suspended.',
                                    timeout: 10000,
                                    icon: 'ni ni-bell-55',
                                    type: 'default',
                                });
                                this.toggleDownlineModal();
                                this.reloadPage();
                            }
                        })
                        .catch ( error => {
                            this.errorFunction(error, "Suspend User")
                        });
                    } 
                })
            },
            onActiveUser(member) {
                swal.fire({
                    title: 'Are you sure you want to re-active this user - <b>'+ member.name +'</b> ?',
                    icon: 'warning',
                    showCancelButton: true,
                    confirmButtonText: 'Yes, re-active it!',
                }).then((result) => {
                /* Read more about isConfirmed, isDenied below */
                    if (result.isConfirmed) {
                        axios.get(services.access_control + 'reactive_user/' + member.id,{ headers: getHeader() })
                        .then ( response => {
                            if (response.status === 200)
                            {
                                this.$notify({
                                    message:
                                        '<b>User : ' + member.name + '</b> - Successfully Reactivated.',
                                    timeout: 10000,
                                    icon: 'ni ni-bell-55',
                                    type: 'default',
                                });
                                this.toggleDownlineModal();
                                this.reloadPage();
                            }
                        })
                        .catch ( error => {
                            this.errorFunction(error, "Suspend User")
                        });
                    } 
                })
            },
            deleteMemberList(user_id) {
                this.editingCard.team_members = this.editingCard.team_members.filter(member => member.id != user_id);
                // this.form.team_member = this.cards[this.editingIndex].team_member.map(member => member.id);
                this.form.team_member = this.form.team_member.filter(member => member != user_id);
            },
            downlineBtn(member) {
                this.toggleDownlineModal();
                this.getUserList();
                this.memberSelected = member;
                this.upline = member.parent_user_id;
            },
            
        }
    }
</script>
